import { BaseModel } from '../../models/base.model';

export class MobileTracking extends BaseModel<MobileTracking> {

    public app_version: string;
    public browserType: string;
    public deviceType: string;
    public osVersion: string;
    public platForm: string;

    public appBuildNumber: string;
    public appClient: string;
    public appPlatform: string;
    public appVersion: string;
    public flow: string;
    public mobileRegistrationId : string;

    constructor(partial?: Partial<MobileTracking>) {
        super({
            app_version: undefined,
            browserType: undefined,
            deviceType: undefined,
            osVersion: undefined,
            platForm: undefined,
            appBuildNumber: undefined,
            appClient: undefined,
            appPlatform: undefined,
            appVersion: undefined,
            flow: undefined,
            mobileRegistrationId: undefined
        }, partial);
    }
}
